/**
 * File: flowkitPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v4.0.1
 * Created: 2025-12-04
 * Last Updated: 2026-02-18
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Images
import uiDashboard from "../../assets/images/ui-dashboard.svg";
import uiHero from "../../assets/images/ui-hero.jpg";

// Icons
import { FaLock } from "react-icons/fa6";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { FaShieldHalved } from "react-icons/fa6";
import { MdMarkEmailRead } from "react-icons/md";

// Flowkit Page
export const flowkitPage = {
    meta: {
        id: "flowkit-page",
    },
    hero: {
        image: uiHero,
        headline: "Smarter MP Calculations Sheets",
        subheadline:
            "Stop maintaining internal tools, save time and standardize your project calculations",
        primaryButton: {
            text: "Get Started",
            type: "primary",
        },
        secondaryButton: {
            text: "Send Inquiry",
            type: "secondary",
        },
    },
    planCard: {
        title: "Purchase Flowkit",
        plans: [
            {
                id: "plan-mp-1",
                header: "Annual Subscription",
                cost: 500,
                currency: "USD",
                model: "/seat",
            },
            {
                id: "plan-mp-2",
                header: "Monthly Subscription",
                cost: 50,
                currency: "USD",
                model: "/seat",
            },
        ],
        features: [
            {
                id: "feature-mp-1",
                icon: <FaRegCalendarCheck />,
                text: "30-Day Money-Back Guarantee",
            },
            {
                id: "feature-mp-2",
                icon: <MdMarkEmailRead />,
                text: "Priority Email Support",
            },
            {
                id: "feature-mp-3",
                icon: <FaShieldHalved />,
                text: "Enterprise-grade Security",
            },
            {
                id: "feature-mp-4",
                icon: <FaLock />,
                text: "100% Data Privacy",
            },
        ],
    },
    articles: [
        {
            id: "article-mp-1",
            reverse: false,
            image: uiDashboard,
            headline: "No More Outdated Internal Tools",
            description:
                "Say goodbye to error-prone Excel files and custom scripts. Our cloud-based calculation sheets are always up-to-date, version-controlled, and built for modern HVAC and plumbing workflows.",
        },
        {
            id: "article-mp-2",
            reverse: true,
            image: uiDashboard,
            headline: "Organize and Standardize Project Calculations",
            description:
                "Keep all your project calculations in one structured, searchable platform. Ensure consistency across your team and improve collaboration with clearly documented inputs and outputs.",
        },
        {
            id: "article-mp-3",
            reverse: false,
            image: uiDashboard,
            headline: "Save Time and Focus on Engineering",
            description:
                "Automate repetitive calculations and reduce manual work. Free up time for real engineering decisions while increasing accuracy and speed across the team.",
        },
    ],
    faq: [
        {
            id: "faq-mp-1",
            header: "What is Flowkit and how does it work?",
            content:
                "Flowkit is a cloud-based platform for performing, organizing, and recording engineering calculations. It provides standardized calculation forms for mechanical and plumbing workflows, helping engineers track design decisions, compare past revisions, and maintain a consistent record of project calculations.",
        },
        {
            id: "faq-mp-2",
            header: "Who is Flowkit designed for?",
            content:
                "Flowkit is built for mechanical and plumbing engineers who want to streamline their project calculations, reduce reliance on error-prone spreadsheets, and improve documentation consistency across teams.",
        },
        {
            id: "faq-mp-3",
            header: "What calculations are included in the software?",
            content:
                "We continually expand our library of engineering forms. Current published forms include water sizing calculations, gas sizing calculations, and other core MEP calculation sheets commonly used across HVAC and plumbing design workflows.",
        },
        {
            id: "faq-mp-4",
            header: "How does version control work for calculations?",
            content:
                "Each time an engineer updates a calculation form, a new version is automatically archived. This preserves the full history of design decisions, making it easy to reference prior calculations, understand changes, and track how systems evolved throughout the project.",
        },
        {
            id: "faq-mp-5",
            header: "Is my data secure?",
            content:
                "Yes. Flowkit stores all project data on industry-grade infrastructure with strict access controls. We do not sell or share company data, and we prioritize security to protect sensitive engineering and project information.",
        },
        {
            id: "faq-mp-6",
            header: "How do engineers export or link forms to project documents?",
            content:
                "All forms can be downloaded in Excel or PDF format. These files can be linked into applicable CAD platforms or included in project documentation packages when publishing plans.",
        },
    ],
    cta: {
        label: "Explore MEP Calculation Tools",
        headline: "Ditch the Spreadsheets for Good",
        description:
            "Join teams replacing outdated tools with purpose-built MEP calculation software. Stay organized, save time, and focus on design - not maintenance.",
    },
};
